import { render } from "./EventsDetails.vue?vue&type=template&id=38e2ccda"
import script from "./EventsDetails.vue?vue&type=script&lang=js"
export * from "./EventsDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__